import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import {
  EmployerApiKey,
  RevocationCadence,
  RosterSyncSettings,
} from './apiRosterSyncTypes'

const BASE_PATH = '/hr/employer_roster_sync/'

const getKeys = (): Promise<AxiosResponse<EmployerApiKey[]>> => {
  return Request.get(BASE_PATH)
}

const getSettings = (): Promise<AxiosResponse<RosterSyncSettings>> => {
  return Request.get(`${BASE_PATH}settings/`)
}

const updateSettings = (payload: {
  enabled?: boolean
  revocationCadence?: RevocationCadence
}): Promise<AxiosResponse<RosterSyncSettings>> => {
  return Request.patch(`${BASE_PATH}settings/`, payload)
}

const generateKey = (
  name?: string
): Promise<AxiosResponse<EmployerApiKey>> => {
  return Request.post(BASE_PATH, name ? { name } : {})
}

const revokeKey = (id: string): Promise<AxiosResponse<EmployerApiKey>> => {
  return Request.post(`${BASE_PATH}${id}/revoke/`)
}

export default {
  getKeys,
  getSettings,
  updateSettings,
  generateKey,
  revokeKey,
}
